"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonsContainer = exports.alignItems = exports.headerStyle = exports.contentStyleMobile = exports.contentStyleDesktop = exports.iconStyleMobile = exports.iconStyleDesktop = exports.rootStyleMobile = exports.rootStyleDesktop = void 0;

var _reactEmotion = require("react-emotion");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var rootStyleDesktop =
/*#__PURE__*/
(0, _reactEmotion.css)("padding:48px 8px;position:relative;");
exports.rootStyleDesktop = rootStyleDesktop;
var rootStyleMobile =
/*#__PURE__*/
(0, _reactEmotion.css)("width:100%;position:relative;height:100%;");
exports.rootStyleMobile = rootStyleMobile;
var iconStyleDesktop =
/*#__PURE__*/
(0, _reactEmotion.css)("width:13.4px;height:13.4px;position:absolute;right:21px;top:21px;cursor:pointer;fill:", _themeConfig.default.color.dark.white, ";");
exports.iconStyleDesktop = iconStyleDesktop;
var iconStyleMobile =
/*#__PURE__*/
(0, _reactEmotion.css)("width:16px;height:16px;fill:", _themeConfig.default.color.dark.white, ";");
exports.iconStyleMobile = iconStyleMobile;
var contentStyleDesktop =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;overflow-y:scroll;padding:0;flex-direction:column;&::-webkit-scrollbar{height:8px;width:0px;border-radius:4px;background-color:", _themeConfig.default.color.dark.white0_06, ";}&::-webkit-scrollbar-thumb{height:8px;border-radius:4px;background-color:", _themeConfig.default.color.dark.mercury, ";}");
exports.contentStyleDesktop = contentStyleDesktop;
var contentStyleMobile =
/*#__PURE__*/
(0, _reactEmotion.css)("overflow:scroll;height:calc(100% - 130px);width:100%;position:absolute;top:60px;&::-webkit-scrollbar{width:0px;background:transparent;height:0px;}");
exports.contentStyleMobile = contentStyleMobile;
var headerStyle =
/*#__PURE__*/
(0, _reactEmotion.css)("height:60px;width:100%;display:flex;align-items:center;padding:0 5px;background:", _themeConfig.default.color.dark.jupiter, ";.iconbutton{margin-right:5px;}");
exports.headerStyle = headerStyle;
var alignItems =
/*#__PURE__*/
(0, _reactEmotion.css)("display:inline-flex;justify-content:center;align-items:center;box-sizing:border-box;");
exports.alignItems = alignItems;
var buttonsContainer =
/*#__PURE__*/
(0, _reactEmotion.css)("margin:17px 0;display:flex;justify-content:space-between;position:absolute;width:calc(100% - 30px);bottom:0;left:15px;");
exports.buttonsContainer = buttonsContainer;